import _defineProperty from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["wallet"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
export var WalletIcon = function WalletIcon(_ref) {
  var wallet = _ref.wallet,
      props = _objectWithoutProperties(_ref, _excluded);

  return wallet && React.createElement("img", _objectSpread({
    src: wallet.adapter.icon,
    alt: "".concat(wallet.adapter.name, " icon")
  }, props));
};